import { render, staticRenderFns } from "./EditExtChnlDlg.vue?vue&type=template&id=32d73e10"
import script from "./EditExtChnlDlg.vue?vue&type=script&lang=js"
export * from "./EditExtChnlDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports